<template>
  <div>
    <el-dialog
      title="群发内容"
      :visible.sync="dialogVisible"
      width="350px"
      :before-close="dialogBeforeClose"
    >
      <div>
        <Iphone
          class="iphone"
          :attachment="attachment"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Iphone from '../customerGroupDetail/iphone.vue'
export default {
  components: {
    Iphone
  },
  model: {
    prop: 'dialogVisible',
    event: 'dialogVisibleChange'
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    attachment: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {}
  },
  methods: {
    dialogBeforeClose () {
      this.$emit('dialogVisibleChange', false)
    }
  }
}
</script>

<style lang="scss" scoped></style>
